export const locationData = [
  {
    id: '10-research-way-n1',
    textDescription: '10 Research Way (N1) Gnd',
    mapUrl: 'https://maps.app.goo.gl/6P62dbXyhu8heHYB6',
    permits: [
      {
        name: 'Orange',
        dataIndex: 0,
      },
      {
        name: 'Red',
        dataIndex: 1,
      },
      {
        name: 'Visitor',
        dataIndex: 4,
      },
    ],
  },
  {
    id: '2-innovation-walk-n1',
    textDescription: '2 Innovation Walk (N1) L1-6',
    mapUrl: 'https://maps.app.goo.gl/nK2dYxBHZZeQbDF47',
    permits: [
      {
        name: 'Blue',
        dataIndex: 5,
      },
      {
        name: 'Red',
        dataIndex: 6,
      },
    ],
  },
  {
    id: '3-alliance-lane-w1',
    textDescription: '3 Alliance Lane (W1)',
    mapUrl: 'https://maps.app.goo.gl/2H4FbzsmkrZRrvQx5',
    permits: [
      {
        name: 'Blue',
        dataIndex: 7,
      },
    ],
  },
  {
    id: '30-ancora-imparo-way-s1',
    textDescription: '30 Ancora Imparo Way (S1)',
    mapUrl: 'https://maps.app.goo.gl/iJZUVbT9s86znHTq8',
    permits: [
      {
        name: 'Orange',
        staticVacancies: 9,
        dataIndex: 8,
      },
    ],
  },
  {
    id: '20-ancora-imparo-way-s2',
    textDescription: '20 Ancora Imparo Way (S2) P1-P4',
    mapUrl: 'https://maps.app.goo.gl/5Qixx9shBi3qcjYQ8',
    permits: [
      {
        name: 'Red',
        dataIndex: 9,
      },
    ],
  },
  {
    id: '52-scenic-blvd-se1',
    textDescription: '52 Scenic Blvd (SE1)',
    mapUrl: 'https://maps.app.goo.gl/XCL53PKeuJHoZFv18',
    combine: true,
    permits: [
      {
        name: 'Red',
        dataIndex: 11,
      },
      {
        name: 'Orange',
        staticVacancies: 8,
        dataIndex: 11,
      },
    ],
  },
  {
    id: '54-scenic-blvd-se2',
    textDescription: '54 Scenic Blvd (SE2)',
    mapUrl: 'https://maps.app.goo.gl/tX4w1GBz1B6k1hnR8',
    permits: [
      {
        name: 'Blue',
        dataIndex: 12,
      },
    ],
  },
  {
    id: '64-scenic-blvd-se3',
    textDescription: '64 Scenic Blvd (SE3)',
    mapUrl: 'https://maps.app.goo.gl/cWeWk4MynHo63THSA',
    permits: [
      {
        name: 'Visitor',
        dataIndex: 13,
      },
    ],
  },
  {
    id: '60-scenic-blvd-se4',
    textDescription: '60 Scenic Blvd (SE4)',
    mapUrl: 'https://maps.app.goo.gl/RsivYfomZrQdJSvL7',
    permits: [
      {
        name: 'Blue',
        dataIndex: 14,
      },
    ],
  },
  {
    id: '62-scenic-blvd-se5',
    textDescription: '62 Scenic Blvd (SE5)',
    mapUrl: 'https://maps.app.goo.gl/2CDrtWd5Kk9MJpbL9',
    permits: [
      {
        name: 'Blue',
        dataIndex: 15,
      },
    ],
  },
];

export const assembleParkingLocations = (
  parkingAvailability // the file we get from storage
) => {
  if (!parkingAvailability) {
    return null;
  }

  const updatedLocations = [];
  locationData.forEach((location) => {
    if (location.combine) {
      const permit = location.permits[0];
      const accessiblePermit = location.permits.find(
        (permit) => permit.name === 'Orange'
      );

      const permitData = {
        id: location.id,
        name: location.textDescription,
        mapUrl: location.mapUrl,
        colour: location.permits.map((permit) => permit.name),
        vacancies: parkingAvailability.Rows[permit.dataIndex].Vacant,
        accessibleSpaces: accessiblePermit.staticVacancies,
      };
      updatedLocations.push(permitData);
    } else {
      location.permits.forEach((permit) => {
        const permitData = {
          id: location.id + '-' + permit.name.toLowerCase(),
          name: location.textDescription,
          mapUrl: location.mapUrl,
          colour: [permit.name],
          accessibleSpaces: permit.staticVacancies,
          vacancies:
            // Orange (accessible) carparks will always have the
            // same number of static vacancies
            permit.staticVacancies ||
            parkingAvailability.Rows[permit.dataIndex].Vacant,
        };
        updatedLocations.push(permitData);
      });
    }
  });
  return updatedLocations;
};

/*
  result looks like: 
  {
    id: '64-scenic-blvd-se3-visitor',
    name: '64 Scenic Blvd (SE3)',
    mapUrl: 'https://maps.app.goo.gl/cWeWk4MynHo63THSA',
    colour: 'Visitor',
    vacancies: 107
  },
*/
